<div *ngIf="isNoResults === true" class="d-flex justify-content-center">{{ message || 'No data found'}}</div>